// PATH: src/components/ui/StatusPill.tsx
import * as React from "react";
import { Box } from "@mui/material";

export type PillTone = "neutral" | "success" | "warning" | "error" | "info" | "primary";

const TONES: Record<PillTone, { bg: string; fg: string; dot: string }> = {
  neutral: { bg: "#F2F4F7", fg: "#344054", dot: "#98A2B3" },
  success: { bg: "#ECFDF3", fg: "#027A48", dot: "#12B76A" },
  warning: { bg: "#FFFAEB", fg: "#B54708", dot: "#F79009" },
  error: { bg: "#FEF3F2", fg: "#B42318", dot: "#F04438" },
  info: { bg: "#EFF8FF", fg: "#175CD3", dot: "#2E90FA" },
  primary: { bg: "#EEF4FF", fg: "#3538CD", dot: "#444CE7" },
};

interface Props {
  tone?: PillTone;
  children: React.ReactNode;
  /** Pastille de couleur avant le texte (état). */
  dot?: boolean;
  title?: string;
}

/** Badge d'état compact, lisible sans dépendre de la couleur seule. */
export const StatusPill: React.FC<Props> = ({ tone = "neutral", children, dot = true, title }) => {
  const c = TONES[tone];
  return (
    <Box
      component="span"
      title={title}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        px: 1,
        py: 0.25,
        borderRadius: 99,
        bgcolor: c.bg,
        color: c.fg,
        fontSize: "0.75rem",
        fontWeight: 600,
        lineHeight: 1.6,
        whiteSpace: "nowrap",
      }}
    >
      {dot && <Box component="span" sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: c.dot }} />}
      {children}
    </Box>
  );
};

export default StatusPill;
